import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { FEAST_PATHS } from './paths';

/** Feast (feature store): таблица признаков с выделенным столбцом. */
export const FeastIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {FEAST_PATHS.map(d => (
      <path key={d} d={d} />
    ))}
  </SvgIcon>
);
